import {ErrorBoundary} from '@frontend/components/ErrorBoundary'
import type {ReactNode} from 'react'

interface Props {
    children: ReactNode | ReactNode[]
}

/*
 * Ограничитель глубины отрабатывания ошибок в JS/JSX.
 * Если ошибка произошла внутри этого компонента, то отображается блок с ошибкой.
 * Ошибка так же не будет влиять на всё приложение
 * (т.е. интерфейс вне компонента продолжит работать вместо полного отказа).
 */
export function InlineErrorBoundary(props: Props) {

    return (
        <ErrorBoundary
            inline
            {...props}
        />
    )
}
